// extracted by mini-css-extract-plugin
export default {"Layer":"Tooltip_Layer__HoroQ","Layer--dark":"Tooltip_Layer--dark__scrnL","Body":"Tooltip_Body__GLPf8","Arrow":"Tooltip_Arrow__kL6Pe"};